module.exports = __webpack_public_path__ + "static/media/direct_lane_1_closure.0e9fbf0f.png";